import React from 'react'
import { makeStyles } from '@material-ui/core'
import { TextareaType } from 'foundations-library/types'
import { RequiredAsterisk, Textarea, Typography } from 'foundations-library/components'

const jss = () => ({
    title: {
        // marginBottom: 5
    },
    subtitle: {
        marginBottom: 15
    }
})

const useStyles = makeStyles(jss)

type PropsInterface = {
    title: string
    subtitle?: string
    required?: boolean
} & TextareaType

/**
 *
 */
const TextareaWithTitles = ({
    title,
    subtitle,
    required = true,
    minHeight = 150,
    ...props
}: PropsInterface): JSX.Element => {
    const styles = useStyles()
    return <div>
        <Typography variant='body1' className={styles.title}>{title}</Typography>
        {
            subtitle &&
            <Typography
                variant='body4'
                color='neutral-400'
                className={styles.subtitle}
            >
                {subtitle}{required && <span> <RequiredAsterisk /></span>}
            </Typography>
        }
        <Textarea minHeight={minHeight} {...props}/>
    </div>
}

export default TextareaWithTitles
